import React from "react";
import { useRouteMatch } from "react-router-dom";

import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import { PageProps } from "src/pages/Router/routes";
import { useOrder } from "src/core/orders/hooks";
import {
  useTransactionApi,
  TransactionStatus
} from "src/modules/payment/api/transactions.api";

interface OrderCheckoutPageProps {
  orderId: string;
}

const ThreeDSecurePage: React.FunctionComponent<PageProps<OrderCheckoutPageProps>> = () => {
  const match = useRouteMatch<OrderCheckoutPageProps>();
  const orderId = React.useMemo(() => parseInt(match.params.orderId, 0), [ match ]);
  const [ { currentOrder } ] = useOrder(orderId, null, true);
  const [ transactionRes, transactionReq ] = useTransactionApi("GET_TRANSACTION");

  React.useEffect(() => {
    if (currentOrder.data?.transactions?.length) {
      const latestTransaction = currentOrder.data?.transactions[ 0 ];

      transactionReq(latestTransaction.id);
    }
  }, [ currentOrder.data, transactionReq ]);

  React.useEffect(() => {
    if (transactionRes.data && (transactionRes.data.status === TransactionStatus.SUCCEEDED || transactionRes.data.status === TransactionStatus.REQUIRES_CAPTURE)) {
      if (window.top) {
        window.top.postMessage({
          type: "3DS-authentication-complete",
          message: { transaction: transactionRes.data }
        });
        transactionRes.data = null;
      }
    } else if (transactionRes.data?.errorReason) {
      if (window.top) {
        window.top.postMessage({
          type: "3DS-authentication-error",
          message: { transaction: transactionRes.data }
        });
        transactionRes.data = null;
      }
    }
  }, [ transactionRes ]);

  return (
    <div>
      <LoadingSpinner
        message="Processing order..."
        type="circular-pulse"
      />
    </div>
  );
};

export default ThreeDSecurePage;
